export const green = {
  50: '#E8F5E9',
  100: '#C8E6C9',
  200: '#A5D6A7',
  300: '#81C784',
  400: '#66BB6A',
  500: '#289B18',
  600: '#43A047',
  700: '#388E3C',
  800: '#2E7D32',
  900: '#1B5E20',
  A100: '#B9F6CA',
  A200: '#69F0AE',
  A400: '#00E676',
  A700: '#00C853',
  contrastDefaultColor: '#fff',
  contrastText: '#fff',
};

export const orange = {
  50: '#FFF3E0',
  100: '#FFE0B2',
  200: '#FFCC80',
  300: '#FFB74D',
  400: '#FFA726',
  500: '#E59F26',
  600: '#FB8C00',
  700: '#F57C00',
  800: '#EF6C00',
  900: '#E65100',
  A100: '#FFD180',
  A200: '#FFAB40',
  A400: '#FF9100',
  A700: '#FF6D00',
  contrastDefaultColor: '#fff',
  contrastText: '#fff',
};

export const grey = {
  50: '#FAFAFA',
  100: '#F5F5F5',
  200: '#9E9E9E',
  300: '#9E9E9E',
  400: '#9E9E9E',
  500: '#9E9E9E',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#9E9E9E',
  A200: '#9E9E9E',
  A400: '#9E9E9E',
  A700: '#9E9E9E',
  contrastDefaultColor: '#fff',
  contrastText: '#fff',
};

export const FRNGreen = '#289B18';
export const FRNLightGreen = '#F7FFF1';
export const FRNLightGreenBackground = '#e0eade';
export const FRNDarkGreyBackground = '#1e2629';
export const FRNOrange = '#E59F26';
export const FRNLightOrange = ' rgba(255,153,0,0.05)';
export const FRNDarkBlueGray= '#37474f';
export const FRNGrey = '#444';
export const FRNGreyLight = '#4d6f7b';
export const FRNRed = '#a94442';
export const FRNRedLight = '#f2dede';
export const black = '#000';
export const darkGray = '#333';
export const white = '#fff';



// WEBPACK FOOTER //
// ./theme/colors.js